import { render, staticRenderFns } from "./TriggerItem.vue?vue&type=template&id=9ed10bb0"
import script from "./TriggerItem.vue?vue&type=script&lang=js"
export * from "./TriggerItem.vue?vue&type=script&lang=js"
import style0 from "./TriggerItem.vue?vue&type=style&index=0&id=9ed10bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports